import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'
import globalStyles from 'src/styles/globalStyles'
import PageTransition from 'src/components/PageTransition'
import ScrollListener from 'src/components/ScrollListener'
import { Global, css } from '@emotion/react'
import IntersectionObserverPolyfill from 'src/components/IntersectionObserverPolyfill'
import AppProvider from 'src/state/AppState'
import OverlayState from 'src/state/OverlayState'
import Modal from 'src/components/Modal'
import ShippingZoneModal from 'src/components/ShippingZoneModal'
import ShopifyProvider from 'src/state/ShopifyState'
import styled from '@emotion/styled'
import './reset.css'

const ClippingSvgs = styled.div`
	height: 0;
	svg {
		display: block;
		width: 0;
		height: 0;
	}
`

const Layout = ({ children, location }) => (
	<StaticQuery
		query={graphql`
			query SiteQuery {
				site {
					siteMetadata {
						title
					}
				}
			}

		`}
		render={({ shopifyAdmin, ...data }) => (
			<IntersectionObserverPolyfill>
				<OverlayState>
					<ShopifyProvider>
						<AppProvider>
							<ScrollListener>
								<Global
									styles={css`
										${ globalStyles }
									`}
								/>
								<PageTransition location={location || { pathName: '/' }}>
									{children}
								</PageTransition>
								<Modal id='modalLocationSelector'>
									<ShippingZoneModal/>
								</Modal>
							</ScrollListener>
						</AppProvider>
					</ShopifyProvider>
				</OverlayState>
				<ClippingSvgs>
					<svg
						className="svg-clip"
						viewBox="0 0 1 1"
						preserveAspectRatio="none"
					>
						<defs>
							<clipPath
								id="raggedThumb1"
								clipPathUnits="objectBoundingBox"
							>
								<path d="M0.99,0.02C1.01,0.09,1,0.2,0.99,0.27c0,0.07,0,0.15,0,0.22C1,0.58,1,0.67,0.99,0.76c-0.01,0.06,0,0.11,0,0.17 C0.98,1.02,0.9,1,0.81,1C0.67,1,0.42,1,0.28,1c-0.05,0-0.1,0-0.15,0C0.1,1,0.06,1,0.03,1C-0.02,0.98,0,0.88,0.01,0.84 c0.01-0.25-0.01-0.5,0-0.75c0-0.06,0.01-0.09,0.09-0.09c0.07,0,0.18,0,0.25,0c0.19,0,0.36,0,0.55,0C0.92,0,0.98-0.01,0.99,0.02z" />
							</clipPath>
							<clipPath
								id="raggedThumb2"
								clipPathUnits="objectBoundingBox"
							>
								<path d="M0.02,0.98c-0.02-0.05-0.01-0.14-0.01-0.2c0-0.1,0.01-0.18,0-0.28C0,0.37,0,0.22,0.01,0.08 c0.01-0.07,0.03-0.07,0.12-0.07C0.29,0.01,0.45,0,0.61,0c0.1,0,0.21,0,0.31,0c0.09,0,0.07,0.08,0.07,0.13C1,0.33,1,0.53,1,0.72 c0,0.06,0,0.12,0,0.19C1,0.93,1,0.96,0.99,0.98C0.97,1,0.94,0.99,0.91,1c-0.17,0.01-0.33-0.01-0.49,0C0.33,1,0.24,1,0.15,1 C0.12,1,0.03,1.01,0.02,0.98z" />
							</clipPath>
							<clipPath
								id="raggedThumb3"
								clipPathUnits="objectBoundingBox"
							>
								<path d="M0.01,0.95c-0.01-0.05,0-0.13,0-0.18C0,0.7,0,0.64,0,0.57c0-0.1,0.01-0.2,0.01-0.3C0.01,0.21,0,0.13,0,0.07 c0-0.06,0.03-0.06,0.11-0.07C0.29,0,0.48,0,0.66,0C0.74,0,0.86,0,0.93,0.01C1.02,0.02,1,0.06,1,0.12C1,0.29,1,0.52,1,0.7 c0,0.06-0.01,0.13-0.01,0.19c0,0.02,0.01,0.05,0,0.07C0.98,0.99,0.94,0.99,0.91,0.99C0.72,1,0.51,0.99,0.32,1C0.26,1,0.18,1,0.11,1 C0.05,1,0.03,1,0.01,0.95z" />
							</clipPath>
							<clipPath
								id="raggedThumb4"
								clipPathUnits="objectBoundingBox"
							>
								<path className="cls-1" d="M.26,1s-.07,0-.11,0c0,0-.02,0-.03,0-.02,0-.04,0-.06,0,0,0-.02,0-.03,0,0,0-.01,0-.02,0,0,0,0-.01,0-.02,0-.01,0-.03,0-.05,0-.01,0-.02,0-.03,0-.02,0-.03,0-.05,0-.02,0-.05,0-.07,0-.02,0-.04,0-.05,0,0,0-.02,0-.03,0-.01,0-.02,0-.03,0,0,0-.01,0-.02,0-.03,0-.05,0-.08,0-.02,0-.03,0-.05,0-.02,0-.03,0-.05,0-.01,0-.03,0-.04,0-.01,0-.03,0-.04,0-.02,0-.05,0-.07,0-.01,0-.02,0-.03,0-.02,0-.04,0-.06,0-.02,0-.04,0-.07,0-.02,0-.05,0-.07,0-.01,0-.03.01-.04,0,0,.01-.01.02-.02,0,0,.02,0,.03,0,0,0,.01,0,.02,0,.03,0,.07,0,.1,0,.01,0,.03,0,.04,0,.01,0,.02,0,.03,0,0,0,.02,0,.03,0,0,0,.02,0,.03,0,0,0,.02,0,.03,0,0,0,.02,0,.03,0,.01,0,.02,0,.03,0,.01,0,.02,0,.04,0,.02,0,.03,0,.05,0,.03,0,.05,0,.08,0,.01,0,.03,0,.04,0,0,0,.02,0,.03,0,.02,0,.04,0,.07,0,.06,0,.11,0,.17,0,.01,0,.02,0,.04,0,0,0,.01,0,.02,0,.01,0,.03,0,.04.01,0,0,.02.02.02.03,0,.01,0,.02,0,.03,0,.01,0,.03,0,.04,0,.02,0,.04,0,.06,0,0,0,.01,0,.02,0,.02,0,.03,0,.05,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.05,0,.02,0,.04,0,.06,0,.02,0,.03,0,.05,0,.03,0,.05,0,.08,0,.01,0,.03,0,.04,0,.02,0,.03,0,.05,0,.02,0,.03,0,.05,0,.03,0,.05,0,.08,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,.02,0,.03-.01.04,0,0-.02,0-.03.01-.01,0-.02,0-.03,0-.01,0-.02,0-.03,0,0,0-.01,0-.02,0-.01,0-.03,0-.04,0-.02,0-.04,0-.06,0-.02,0-.04,0-.06,0-.01,0-.03,0-.04,0-.01,0-.02,0-.04,0-.01,0-.02,0-.04,0-.01,0-.03,0-.04,0-.05,0-.1,0-.14,0-.02,0-.03,0-.05,0-.04,0-.07,0-.1,0Z"/>
							</clipPath>
							<clipPath
								id="raggedThumbBleedLeft"
								clipPathUnits="objectBoundingBox"
							>
								<path
									className="st0"
									d="M0.71,0.99c-0.08,0-0.16,0-0.24,0C0.38,1,0.29,1,0.2,0.99C0.13,0.98,0.07,1,0,0.99c0,0,0,0,0,0 c0,0,0-0.95,0-0.98c0.02,0,0.06,0,0.1,0C0.37,0,0.63,0,0.9,0c0.11,0,0.09,0.01,0.1,0.09c0,0.07,0,0.18,0,0.25c0,0.19,0,0.4,0,0.58 c0,0.02,0.01,0.05-0.01,0.06C0.9,1.01,0.79,1,0.71,0.99z"
								/>
							</clipPath>
							<clipPath
								id="raggedThumbBleedRight"
								clipPathUnits="objectBoundingBox"
							>
								<path d="M.29,0c.08,0,.16,0,.24,0,.09,0,.19,0,.28,0,.07.01.13-.01.19,0,0,0,0,0,0,0v.98s-.06,0-.1,0c-.27,0-.53,0-.8,0-.11,0-.09,0-.1-.09,0-.07,0-.18,0-.25C0,.47,0,.26,0,.08,0,.05,0,.02.02.01.1-.01.21,0,.29,0Z"/>
							</clipPath>
							<clipPath
								id="raggedThumbFullBleed"
								clipPathUnits="objectBoundingBox"
							>
								<path
									className="st0"
									d="M1,0.03C0.85,0,0.61-0.01,0.48,0.01c-0.1,0.02-0.2-0.01-0.3,0C0.12,0.01,0.05,0,0,0.02V1 c0.07,0,0.18-0.01,0.24,0c0.21,0.01,0.43,0,0.64-0.01c0.02,0,0.07,0,0.12,0.01V0.03z"
								/>
							</clipPath>
							<clipPath
								id="raggedTopLeft"
								clipPathUnits="objectBoundingBox"
							>
								<path
									d="M1,0H0c0,0.25,0,0.98,0,0.98c0,0,0,0,0,0C0.07,1,0.13,0.97,0.2,0.98C0.28,1,0.38,1,0.47,0.99
c0.08,0,0.16,0,0.24,0c0.08,0,0.19,0.02,0.27-0.01C1,0.98,0.99,0.94,0.99,0.92c0-0.2,0-0.43,0-0.63C0.99,0.2,1,0.09,1,0C1,0,1,0,1,0
z"
								/>
							</clipPath>
							<clipPath
								id="raggedEdgeTopBottom"
								clipPathUnits="objectBoundingBox"
							>
								<path className="st0" d="M0.76,0.01c-0.21-0.02-0.43,0-0.64,0.01C0.1,0.02,0.05,0.01,0,0.01v0.98c0.07,0.01,0.18-0.01,0.24,0
c0.21,0.02,0.43,0,0.64-0.01C0.9,0.98,0.95,0.99,1,0.99V0.01C0.93,0,0.82,0.01,0.76,0.01z"/>
							</clipPath>
							<clipPath
								id="raggedEdgeBottom"
								clipPathUnits="objectBoundingBox"
							>
								<path
									className="st0"
									d="M0,0v1c0.07,0,0.18-0.01,0.24,0c0.21,0.01,0.43,0,0.64-0.01c0.02,0,0.07,0,0.12,0.01V0H0z"
								/>
							</clipPath>
							<clipPath id="cocktailHero" clipPathUnits="objectBoundingBox">
								<path className="st0" d="M0.74,1C0.71,0.99,0.62,0.98,0.6,0.94c0.01,0.09-0.17-0.02-0.19-0.05C0.37,0.91,0.32,0.92,0.27,0.93 c-0.04,0.01-0.06,0.03-0.09,0C0.13,0.91,0.14,0.87,0.13,0.83C0.11,0.78,0.06,0.77,0.05,0.73C0.04,0.69,0.07,0.63,0.09,0.6 C0.07,0.57,0.03,0.57,0.01,0.52c-0.02-0.04-0.01-0.06,0-0.1c0.01-0.03,0.01-0.08,0.04-0.11C0.06,0.29,0.1,0.28,0.12,0.27 c0-0.02-0.02-0.04-0.03-0.06c0-0.02-0.01-0.01-0.01-0.02c0-0.02,0.07-0.06,0.09-0.07c0.04-0.03,0.09-0.07,0.14-0.08 c0.04-0.01,0.07-0.01,0.11-0.03C0.5-0.03,0.53,0.04,0.61,0.06c0.04,0.01,0.07-0.03,0.11-0.01c0.04,0.01,0.05,0.02,0.07,0.05 c0.05,0.06,0.13,0.08,0.16,0.16c0.02,0.04,0,0.06,0,0.1c0,0.03,0.03,0.04,0.04,0.06c0.01,0.04-0.03,0.06-0.06,0.09 c-0.03,0.04-0.02,0.05,0,0.09C0.96,0.62,0.95,0.7,0.91,0.73C0.88,0.75,0.83,0.71,0.82,0.75C0.81,0.79,0.86,0.83,0.84,0.88 C0.82,0.92,0.78,1.01,0.74,1z"/>
							</clipPath>
							<clipPath id="cardSquare" clipPathUnits="objectBoundingBox">
								<path d="M0.995993 0.742952C0.995993 0.783573 0.995725 0.81724 0.996184 0.850906C0.996299 0.859566 0.996318 0.868246 0.997064 0.876896C0.998748 0.896671 0.997963 0.916456 0.997581 0.936231C0.997409 0.945145 0.996012 0.954078 0.993238 0.962942C0.991517 0.968436 0.989642 0.973843 0.985242 0.978977C0.981818 0.982971 0.97472 0.984929 0.968025 0.986984C0.953849 0.991348 0.938086 0.993073 0.92173 0.99391C0.910922 0.994475 0.900132 0.994397 0.889362 0.994271C0.874039 0.994086 0.858792 0.993209 0.843526 0.992459C0.820895 0.991348 0.79815 0.990842 0.775481 0.991524C0.757498 0.992069 0.739707 0.991329 0.721821 0.991007C0.71216 0.990832 0.702557 0.990335 0.692954 0.989916C0.681801 0.989429 0.670705 0.988592 0.659552 0.988114C0.652302 0.987802 0.64509 0.987403 0.63784 0.987072C0.611593 0.985864 0.58527 0.985094 0.558928 0.98562C0.542859 0.985942 0.526866 0.986858 0.510988 0.98829C0.494881 0.989741 0.478811 0.991358 0.46257 0.992439C0.44805 0.993404 0.433645 0.994777 0.419145 0.995722C0.406002 0.99658 0.392764 0.997057 0.379584 0.997758C0.356092 0.999005 0.332524 0.999424 0.308917 0.999823C0.29765 1.00002 0.286363 1.00022 0.275114 1.00007C0.256118 0.999804 0.237065 0.999541 0.218164 0.998606C0.196241 0.997515 0.174375 0.996102 0.152682 0.993959C0.127908 0.991514 0.103365 0.988718 0.0794329 0.984627C0.0647601 0.982113 0.0513116 0.978519 0.0408284 0.972469C0.032392 0.967599 0.0269591 0.961939 0.0231713 0.955812C0.0180253 0.947415 0.0154619 0.938745 0.0137784 0.930055C0.012688 0.924444 0.0120567 0.918804 0.0114828 0.913154C0.00811593 0.879858 0.0108707 0.846532 0.00949329 0.813236C0.00897678 0.800679 0.00974198 0.788113 0.00859418 0.775576C0.00754202 0.764227 0.00880461 0.752878 0.00761854 0.741559C0.00664291 0.732236 0.00782897 0.722913 0.0067003 0.71363C0.00553336 0.704064 0.0068916 0.694498 0.00572466 0.684971C0.00459599 0.675736 0.00589683 0.666491 0.00478729 0.657285C0.00362035 0.647719 0.00494033 0.638153 0.00383078 0.628626C0.00252994 0.617365 0.00402208 0.606094 0.00287428 0.594853C0.00159256 0.582452 0.00304645 0.570051 0.0019369 0.557669C0.000502144 0.541703 0.00197516 0.525737 0.00103779 0.509781C-0.000511752 0.483596 -1.43713e-05 0.457411 0.0005404 0.431226C0.00080822 0.418425 8.12769e-05 0.405606 0.00142038 0.392835C0.00241514 0.383269 0.00143951 0.373722 0.00220471 0.364166C0.00396468 0.341965 0.0024534 0.319745 0.00319947 0.297534C0.00507422 0.241336 0.00304643 0.185128 0.00432814 0.128929C0.00459596 0.116948 0.0039838 0.104936 0.00524638 0.0929738C0.0059542 0.0862425 0.00524638 0.0795306 0.0059542 0.0728285C0.0074846 0.058606 0.00949326 0.044403 0.0192305 0.0308527C0.0254286 0.0222218 0.034458 0.0147501 0.0516942 0.0106977C0.0618523 0.00831101 0.072546 0.00789209 0.0835266 0.00790183C0.0968603 0.00792131 0.110117 0.00910013 0.123394 0.00888581C0.144112 0.00854486 0.16481 0.00770704 0.185509 0.00707385C0.191994 0.00687902 0.198479 0.0068888 0.204984 0.00663552C0.22046 0.00604129 0.236032 0.00599258 0.251546 0.00552499C0.270848 0.0049405 0.290131 0.00437545 0.309472 0.00401501C0.321964 0.00378122 0.334475 0.00334287 0.346967 0.00306037C0.36361 0.00268045 0.380253 0.00244663 0.396896 0.00206672C0.415453 0.00163809 0.434009 0.00149203 0.452546 0.0010634C0.46829 0.000693229 0.484034 0.00110233 0.499721 0.000634742C0.525011 -0.000125091 0.5503 0.000108687 0.575552 0.000391187C0.589536 0.000547049 0.60352 0.000449641 0.617485 0.000722401C0.634607 0.00105361 0.651728 0.00130691 0.66885 0.00171605C0.684823 0.0021057 0.700835 0.00239796 0.716732 0.00318701C0.743074 0.00450211 0.769455 0.00427798 0.795797 0.00397599C0.817203 0.00373245 0.838648 0.00346942 0.860036 0.00295312C0.873733 0.00262191 0.887392 0.00269993 0.900878 0.00327467C0.915895 0.00390786 0.930568 0.00215443 0.945451 0.00262202C0.964677 0.00322599 0.973687 0.00692765 0.980632 0.0151202C0.988111 0.0239459 0.99056 0.0333075 0.992186 0.0427859C0.993965 0.0530923 0.994463 0.0634182 0.995113 0.0737539C0.995859 0.0853949 0.996299 0.0970554 0.997179 0.108687C0.997734 0.116139 0.997141 0.123601 0.997983 0.131034C0.999647 0.14586 0.997982 0.160706 0.998958 0.175523C1.00034 0.19636 1.0002 0.217197 0.999398 0.238024C0.998671 0.257399 0.999876 0.276785 0.998518 0.296141C0.997562 0.309594 0.998843 0.323057 0.997581 0.33649C0.996471 0.348238 0.997829 0.359996 0.996643 0.371735C0.995381 0.384136 0.996911 0.396546 0.995668 0.408918C0.994367 0.421961 0.9954 0.435005 0.994845 0.448049C0.992836 0.496133 0.99387 0.544226 0.994271 0.59232C0.994405 0.60925 0.994099 0.6262 0.995017 0.643131C0.996969 0.678716 0.995285 0.714312 0.995993 0.742952Z" fill="#C36251"/>
							</clipPath>
						</defs>
					</svg>
				</ClippingSvgs>
			</IntersectionObserverPolyfill>
		)}
	/>
)

Layout.propTypes = {
	children: PropTypes.node.isRequired,
}

export default Layout
